module.exports = __webpack_public_path__ + "media/Complete.2de68ec1.wav";